import { render } from "./AddTaxes.vue?vue&type=template&id=41811b99&scoped=true"
import script from "./AddTaxes.vue?vue&type=script&lang=js"
export * from "./AddTaxes.vue?vue&type=script&lang=js"

import "./AddTaxes.vue?vue&type=style&index=0&id=41811b99&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41811b99"]])

export default __exports__